var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('logged-in-layout',[_c('main',[_c('header',{class:_vm.$style.header},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Recordings")]),_vm._v(" "),(_vm.user.crmRequired)?_c('router-link',{attrs:{"to":"/tasks"}},[_vm._v("Log Activity")]):_vm._e(),_vm._v(" "),_c('router-link',{attrs:{"to":"/focus"}},[_vm._v("Focus")])],1),_vm._v(" "),_c('router-view',{attrs:{"is-rep":_vm.isRep}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1361d200","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Home.vue
// module id = 0itC
// module chunks = 1